import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowUpIcon, ArrowDownIcon, LucideIcon } from "lucide-react";

interface StatCardProps {
  title: string;
  value: string;
  trend: "up" | "down";
  bgColor: string;
  subtitle?: string;
}

const StatCard = ({ title, value, trend, bgColor, subtitle = "Último mes" }: StatCardProps) => {
  const Icon = trend === "up" ? ArrowUpIcon : ArrowDownIcon;
  
  return (
    <Card className={bgColor}>
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <p className="text-sm font-medium">{title}</p>
          <Icon className={`h-4 w-4 ${trend === "up" ? "text-primary-foreground" : "text-accent-foreground"}`} />
        </div>
        <p className="text-2xl font-bold mt-4">{value}</p>
        <p className="text-xs text-muted-foreground mt-2">{subtitle}</p>
      </CardContent>
    </Card>
  );
};

export default StatCard;